var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mimeType !== null)?_c('VueRecordAudio',{attrs:{"mimeType":_vm.mimeType},on:{"result":_vm.storeRecord,"stream":_vm.stream}}):_c('VueRecordAudio',{on:{"result":_vm.storeRecord,"stream":_vm.stream}})}
var staticRenderFns = []

export { render, staticRenderFns }